import React from 'react';
import StatAnalysisComponent from "./StatAnalysisComponent";
import {padCalendar} from "../../../util";


const formatStatResidualReturns = (statResidualReturns) => {
	for (const statResidualReturn of statResidualReturns) {
		statResidualReturn.date = padCalendar(statResidualReturn.date);
		if (statResidualReturn.statSignificance === false) {
			statResidualReturn.statSignificance = 'No'
		} else if (statResidualReturn.statSignificance === true) {
			statResidualReturn.statSignificance = 'Yes'
		}
	}

	return statResidualReturns;
};


const StatAnalysisContainer = (props) => {

	if (!props.statResidualReturns) {
		return <div>Loading</div>
	}

	let data = formatStatResidualReturns(props.statResidualReturns);

	return (
		<React.Fragment>
			<StatAnalysisComponent statResidualReturns={data} isDandO={sessionStorage.getItem('DANDO')} claimTypeId={props.claimTypeId}/>
		</React.Fragment>
	);

};


export default StatAnalysisContainer;


// WEBPACK FOOTER //
// ./src/common/components/StatAnalysis/StatAnalysisContainer.js